
export enum ContentLibraryLinks {
  EN = 'https://bkbn.com/content-library',
  FR = 'https://bkbn.com/fr/bibliotheque-contenus',
  DE = 'https://bkbn.com/de/inhalte-bibliothek',
  ES = 'https://bkbn.com/es/biblioteca-de-contenido',
  NL = 'https://bkbn.com/nl/contentbibliotheek',
  ALL_PURPOSE = 'https://bkbn.com/content-library',
}
